// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(orderType) {
  switch (orderType) {
    case "dummy" :
        return /* Dummy */2;
    case "fixed" :
        return /* Fixed */1;
    case "fixed dummy" :
        return /* FixedDummy */3;
    case "spot" :
        return /* Spot */0;
    default:
      return ErrorUtils$Catalyst.raiseError("OrderType.re", "Invalid order type", orderType);
  }
}

function toString(orderType) {
  switch (orderType) {
    case /* Spot */0 :
        return "spot";
    case /* Fixed */1 :
        return "fixed";
    case /* Dummy */2 :
        return "dummy";
    case /* FixedDummy */3 :
        return "fixed dummy";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var orders = {
  hd: /* Spot */0,
  tl: /* [] */0
};

export {
  orders ,
  fromString ,
  toString ,
  t_decode ,
  
}
/* No side effect */
